import {TextInput} from '@dropbox/dig-components/text_fields';
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import {type ComponentPropsWithoutRef, type ReactNode, useId} from 'react';

type WorkstreamModalFieldProps = ComponentPropsWithoutRef<typeof TextInput> & {
  label: ReactNode;
  error?: string;
};

export const WorkstreamModalFieldError = ({children, id}: {children: ReactNode; id?: string}) => (
  <Text id={id} size="small" color="error" aria-live="polite">
    {children}
  </Text>
);

export const WorkstreamModalField = ({
  label,
  error,
  id,
  isInvalid,
  'aria-describedby': describedBy,
  ...inputProps
}: WorkstreamModalFieldProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const errorId = `${inputId}-error`;
  const descriptionIds = [describedBy, error ? errorId : undefined].filter(Boolean).join(' ');

  return (
    <Stack gap="16">
      <Stack gap="4">
        <Text tagName="label" htmlFor={inputId} size="xsmall" color="subtle">
          {label}
        </Text>
        <TextInput
          {...inputProps}
          id={inputId}
          isInvalid={isInvalid || Boolean(error)}
          aria-describedby={descriptionIds || undefined}
        />
      </Stack>
      {error && <WorkstreamModalFieldError id={errorId}>{error}</WorkstreamModalFieldError>}
    </Stack>
  );
};
